var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "hero is-medium" }, [
    _c("div", { staticClass: "hero-body" }, [
      _c(
        "div",
        { staticClass: "content container has-text-centered" },
        [
          _c("h1", { staticClass: "title is-1" }, [_vm._v("404")]),
          _vm._v(" "),
          _c("h1", { staticClass: "subtitle is-6" }, [
            _vm._v("La página o recurso no se encuentra disponible"),
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            { staticClass: "button is-dark", attrs: { to: "/" } },
            [_vm._v("\n        Volver al inicio\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }